/** Use it instead of .includes method for IE support */

export function arrayIncludes() {
  var array = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var itemOrItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  if (Array.isArray(itemOrItems)) {
    return itemOrItems.every(function (item) {
      return array.indexOf(item) !== -1;
    });
  }
  return array.indexOf(itemOrItems) !== -1;
}